webpackJsonp([60335399758886],{

/***/ "./node_modules/json-loader/index.js!./.cache/json/index.json":
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"author":"Bartholomew Joyce"}},"markdownRemark":{"html":"<h2>Term 1 modules</h2>\n<ul>\n<li>\n<p><a href=\"/cs301/\"><code>CS301</code> Complexity of Algorithms</a></p>\n</li>\n<li>\n<p><a href=\"/cs325/\"><code>CS325</code> Compiler Design</a></p>\n</li>\n<li>\n<p><a href=\"/cs324/\"><code>CS324</code> Computer Graphics</a></p>\n</li>\n<li>\n<p><a href=\"/cs346/\"><code>CS346</code> Advanced Databases</a></p>\n</li>\n<li>\n<p><a href=\"/st301/\"><code>ST301</code> Bayesian Statistics and Decision Theory</a></p>\n</li>\n</ul>\n<h2>Term 2 modules</h2>\n<ul>\n<li>\n<p><a href=\"/cs342/\"><code>CS342</code> Machine Learning</a></p>\n</li>\n<li>\n<p><a href=\"/cs356/\"><code>CS356</code> Approximation and Randomised Algorithms</a></p>\n</li>\n<li>\n<p><a href=\"/cs313/\"><code>CS313</code> Mobile Robotics</a></p>\n</li>\n</ul>","excerpt":"Term 1 modules  Complexity of Algorithms  Compiler Design  Computer Graphics  Advanced Databases  Bayesian Statistics and Decision Theory…","frontmatter":{"title":"Notes","date":"October 03, 2017"}}},"pathContext":{"slug":"//"}}

/***/ }),

/***/ "./node_modules/json-loader/index.js!./.cache/json/layout-index.json":
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path----60561b1c1217b4bdaf75.js